import {handleActions} from 'redux-actions'
import {
  updateAvatars,
  addAvatar,
  cancelAvatar,
  updateActiveAvatar
} from './actions'

export const initialState = {
  loaded: false,
  avatars: []
}

export default handleActions(
  {
    [updateAvatars](state, {payload}) {
      return {
        ...state,
        loaded: !!payload,
        avatars: payload
          ? Object.keys(payload).map((id) => ({id, ...payload[id]}))
          : []
      }
    },

    [addAvatar](state, {payload}) {
      return {
        ...state,
        avatars: state.avatars.concat(payload)
      }
    },

    [cancelAvatar](state, {payload}) {
      return {
        ...state,
        avatars: state.avatars.filter((avatar) => avatar.id !== payload)
      }
    },

    [updateActiveAvatar](state, {payload}) {
      return {
        ...state,
        avatars: state.avatars.map((avatar) => ({
          ...avatar,
          isActive: avatar.id === payload
        }))
      }
    }
  },
  initialState
)
